import { Logo, Navbar } from "@/components/landing/Navbar";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { MarketingLink } from "@/components/OptionalLink";
import { isAbsoluteUrl } from "next/dist/shared/lib/utils";

const footer = [
  {
    title: "Product",
    links: [
      {
        label: "Launch app",
        href: "/r"
      },
      {
        label: "Pricing",
        href: "/pricing"
      },
      {
        label: "FAQ",
        href: "/faq"
      },
      {
        label: "Docs",
        href: "https://docs.dollardeploy.com"
      }
    ]
  },
  {
    title: "Resources",
    links: [
      {
        label: "Blog",
        href: "/blog/"
      },
      {
        label: "Twitter",
        href: "https://x.com/dollardeploy"
      },
      {
        label: "YouTube",
        href: "https://youtube.com/@dollardeploy"
      },
      {
        label: "Discord",
        href: "https://discord.gg/BHbfmaAGb7"
      },
      {
        label: "GitHub",
        href: "https://github.com/dollardeploy"
      }
    ]
  },
  {
    title: "Company",
    links: [
      {
        label: "About us",
        href: "/team"
      },
      {
        label: "LinkedIn",
        href: "https://www.linkedin.com/company/dollardeploy"
      },
      {
        label: "Privacy Policy",
        href: "/privacy"
      },
      {
        label: "Terms of Service",
        href: "/tos"
      }
    ]
  }
];

const FooterNav = () => {
  return (
    <div className="container grid grid-cols-3 md:grid-cols-6 lg:grid-cols-6 gap-x-4 gap-y-6 py-4 md:w-[700px] lg:w-[700px]">
      {/* Brand Column */}
      <div className="flex flex-col gap-4 col-span-3 md:col-start-1 md:col-span-3 lg:col-start-1 lg:col-span-3 items-center md:items-start lg:items-start">
        <div className="inline-flex flex-col gap-2">
          <div className="flex items-center gap-2 justify-center md:justify-start lg:justify-start">
            <Logo />
          </div>
          <p className="text-md font-semibold text-muted-foreground text-center md:text-left lg:text-left">
            Your Apps. Your Infra.{" "}
            <span className="bg-gradient-to-r from-blue-500 via-sky-500 to-blue-600 text-transparent bg-clip-text">
              Zero DevOps.
            </span>
          </p>
        </div>
      </div>

      {footer.map(({ title, links }, index) => (
        <div
          key={index}
          className={cn(
            "col-span-1 md:col-span-1 lg:col-span-1 flex flex-col gap-1 items-center md:items-start"
          )}
        >
          <h3 className="font-semibold text-left">{title}</h3>
          {links.map(({ label, href }, linkIndex) => (
            <Button
              key={linkIndex}
              variant="link"
              className="justify-start p-0 h-6 text-secondary-foreground"
              asChild
            >
              <MarketingLink
                href={href}
                target={isAbsoluteUrl(href) ? "_blank" : undefined}
                rel={isAbsoluteUrl(href) ? "noreferrer noopener" : undefined}
                className={`plausible-event-name=Footer${label.replace(" ", "")}`}
              >
                {label}
              </MarketingLink>
            </Button>
          ))}
        </div>
      ))}
    </div>
  );
};

export const MarketingShell = ({
  children,
  className,
  themeToggle = true
}: {
  children: React.ReactNode;
  className?: string;
  themeToggle?: boolean;
}) => (
  <div
    className={cn(
      "MarketingShell flex flex-col justify-center min-h-screen border border-transparent"
    )}
  >
    <Navbar themeToggle={themeToggle} />

    <div className={cn("mt-14", className)}>{children}</div>

    <footer
      className={cn(
        "mt-8 pb-4 lg:pt-0 lg:pb-0 flex flex-col justify-center items-center gap-4"
      )}
    >
      <FooterNav />

      <div className="text-center text-sm text-muted-foreground mb-4">
        <p>Built with ❤️ in Helsinki, Finland.</p>
        <p>&copy; 2024-{new Date().getFullYear()} Wizecore</p>
      </div>
    </footer>
  </div>
);
